import { render } from "./LoaderOld.vue?vue&type=template&id=20f6d530"
import script from "./LoaderOld.vue?vue&type=script&lang=js"
export * from "./LoaderOld.vue?vue&type=script&lang=js"

import "./LoaderOld.vue?vue&type=style&index=0&id=20f6d530&lang=css"

import exportComponent from "/Users/iammaham/Documents/JS/estate_soluce/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__